import Vue from 'vue';
import { MutationTree } from "vuex";
import { TaxPricePeriodTranslationAdminzoneState } from "@/types/store/adminzone/tax_price_period_translation";
import { TaxPricePeriodTranslationData } from "@/types/tax_price_period_translation";

export const mutations: MutationTree<TaxPricePeriodTranslationAdminzoneState> = {
  SET_TAX_PRICE_PERIOD_TRANSLATION: (state, payload: Array<TaxPricePeriodTranslationData>): Array<TaxPricePeriodTranslationData> => Vue.set(state, 'taxPricePeriodTranslation', payload)
}
